function NotAdult() {
    return (
      <div className="button">
        <h3>NON, J'AI MOINS DE 18 ANS</h3>
      </div>
    );
  }
  
  export default NotAdult;
  